export const isEmptyUser=(element)=>{
    if(element==''){
        return true
    }
    else{
        return false
    }
}